import * as React from 'react';
import {
    BooleanInput,
    DateTimeInput,
    Edit,
    email,
    FieldProps,
    NumberInput,
    required,
    SelectInput,
    SimpleForm,
    TextInput, useRecordContext,
    useTranslate,
} from 'react-admin';
import {Box, Grid, Step, StepLabel, Stepper, Typography} from '@mui/material';

import PayoutTransactionEditToolbar from './PayoutTransactionEditToolbar';
import {validateForm} from "../../businesses/BusinessEdit";
import {Payout} from "../../types";
import PayoutIdField from './PayoutIdField';

const Separator = () => <Box pt="1em"/>;

const StateTimelines = () => {

    const record = useRecordContext<Payout>();
    // @ts-ignore
    const {stateTimeline = []} = record;
    const translate = useTranslate();
    const [activeStep, setActiveStep] = React.useState(stateTimeline?.length);
    return (
        <Box sx={{maxWidth: 250}}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {stateTimeline.map((step: any) => (
                    <Step key={step.state}>
                        <StepLabel
                            optional={
                                <Typography variant="caption">{new Date(step.date).toLocaleString()}</Typography>
                            }
                        >
                            {step.state}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};


const PayoutTransactionEdit = () => {
    const translate = useTranslate();
    return (
        <Edit title={<PayoutTitle/>}>
            <SimpleForm
                validate={validateForm}
                toolbar={<PayoutTransactionEditToolbar/>}
            >
                <div>
                    <Grid container width={{xs: '100%', xl: 1400}} spacing={2}>
                        <Grid item xs={12} md={8}>


                            <Typography variant="h6" gutterBottom>
                                {translate(
                                    'resources.payout.fieldGroups.payoutRequest'
                                )}
                            </Typography>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        type={"string"}
                                        source="payoutRequest.payoutDescription"
                                        label='resources.payout.page.payoutRequest.payoutDescription'
                                        resource="payouts"
                                        fullWidth
                                        multiline={true}
                                        resettable={true}
                                        helperText={false}
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <DateTimeInput
                                        source="payoutRequest.serviceDate"
                                        label='resources.payout.page.payoutRequest.serviceDate'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <NumberInput
                                        source="payoutRequest.serviceAmount"
                                        label='resources.payout.page.payoutRequest.serviceAmount'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <NumberInput
                                        source="payoutRequest.taxPercentage"
                                        label='resources.payout.page.payoutRequest.taxPercentage'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <NumberInput
                                        source="payoutRequest.totalAmount"
                                        label='resources.payout.page.payoutRequest.totalAmount'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <NumberInput
                                        step={1}
                                        source="payoutRequest.referenceInvoiceNumber"
                                        label='resources.payout.page.payoutRequest.referenceInvoiceNumber'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <TextInput
                                        source="payoutRequest.invoiceId"
                                        label='resources.payout.page.payoutRequest.invoiceId'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <BooleanInput
                                        row={true}
                                        resource="payouts"
                                        source="payoutRequest.invoiceDocAvailable"
                                        label='resources.payout.page.payoutRequest.invoiceDocAvailable'
                                        helperText={false}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <TextInput
                                        source="payoutRequest.invoiceDocUrl"
                                        label='resources.payout.page.payoutRequest.invoiceDocUrl'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                    />
                                </Box>
                            </Box>

                            <Separator/>
                            <Box mt="1em"/>

                            <Typography variant="h6" gutterBottom>
                                {translate(
                                    'resources.payout.fieldGroups.businessInformation'
                                )}
                            </Typography>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        source="businessInformation.businessLegalName"
                                        label='resources.payout.page.businessInformation.businessLegalName'
                                        resource="payouts"
                                        fullWidth
                                        disabled={true}
                                        helperText={false}
                                    />
                                </Box>
                            </Box>

                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        source="businessInformation.firstName"
                                        label='resources.payout.page.businessInformation.firstName'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <TextInput
                                        source="businessInformation.lastName"
                                        label='resources.payout.page.businessInformation.lastName'
                                        resource="payouts"
                                        fullWidth
                                        disabled={true}
                                        helperText={false}
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        source="businessInformation.clientId"
                                        label='resources.payout.page.businessInformation.clientId'
                                        resource="payouts"
                                        fullWidth
                                        disabled={true}
                                        helperText={false}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <TextInput
                                        type="email"
                                        source="businessInformation.businessEmail"
                                        label='resources.payout.page.businessInformation.businessEmail'
                                        resource="payouts"
                                        fullWidth
                                        disabled={true}
                                        helperText={false}
                                    />
                                </Box>
                            </Box>
                            <Typography variant="h6" gutterBottom>
                                {translate(
                                    'resources.payout.page.businessInformation.logo.details'
                                )}
                            </Typography>

                            <Box flex={1} >
                                <Box display={{xs: 'block', sm: 'flex'}}>
                                    <Box flex={1} >
                                        <BooleanInput
                                            row={true}
                                            resource="payouts"
                                            source="businessInformation.logo.logoAvailable"
                                            label='resources.payout.page.businessInformation.logo.logoAvailable'
                                            disabled={true}
                                        />
                                    </Box>
                                    <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                        <TextInput
                                            source="businessInformation.logo.displayLogoUrl"
                                            label='resources.payout.page.businessInformation.logo.displayLogoUrl'
                                            resource="payouts"
                                            fullWidth
                                            disabled={true}
                                        />
                                    </Box>
                                </Box>
                            </Box>

                            <Separator/>
                            <Box mt="1em"/>

                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <Typography variant="h6" gutterBottom>
                                        {translate(
                                            'resources.payout.page.businessInformation.accountInformation.details'
                                        )}
                                    </Typography>








                                    <TextInput
                                        source="businessInformation.accountInformation.businessDirectoryId"
                                        resource="payouts"
                                        label='resources.payout.page.businessInformation.accountInformation.businessDirectoryId'
                                        multiline
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                    <Box display={{xs: 'block', sm: 'flex'}}>
                                        <Box flex={1} >
                                            <TextInput
                                                source="businessInformation.accountInformation.businessBankName"
                                                resource="payouts"
                                                fullWidth
                                                label='resources.payout.page.businessInformation.accountInformation.businessBankName'
                                                helperText={false}
                                                disabled={true}
                                            />
                                        </Box>
                                    </Box>
                                    <Box display={{xs: 'block', sm: 'flex'}}>
                                        <Box flex={1} >
                                            <TextInput
                                                source="businessInformation.accountInformation.businessDisplayAccountNumber"
                                                resource="payouts"
                                                fullWidth
                                                label='resources.payout.page.businessInformation.accountInformation.businessDisplayAccountNumber'
                                                helperText={false}
                                                disabled={true}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <Typography variant="h6" gutterBottom>
                                        {translate(
                                            'resources.payout.page.businessInformation.businessAddress.address'
                                        )}
                                    </Typography>
                                    <Box display={{xs: 'block', sm: 'flex'}}>
                                        <Box flex={1} >
                                            <TextInput
                                                source="businessInformation.businessAddress.addressLineOne"
                                                resource="payouts"
                                                label='resources.payout.page.businessInformation.businessAddress.addressLineOne'
                                                multiline
                                                fullWidth
                                                helperText={false}
                                                disabled={true}
                                            />
                                        </Box>
                                    </Box>
                                    <Box display={{xs: 'block', sm: 'flex'}}>
                                        <Box flex={1} >
                                            <TextInput
                                                source="businessInformation.businessAddress.addressLineTwo"
                                                resource="payouts"
                                                label='resources.payout.page.businessInformation.businessAddress.addressLineTwo'
                                                multiline
                                                fullWidth
                                                helperText={false}
                                                disabled={true}
                                            />
                                        </Box>
                                    </Box>
                                    <Box display={{xs: 'block', sm: 'flex'}}>
                                        <Box flex={1} >
                                            <TextInput
                                                source="businessInformation.businessAddress.city"
                                                resource="payouts"
                                                fullWidth
                                                label='resources.payout.page.businessInformation.businessAddress.city'
                                                helperText={false}
                                                disabled={true}
                                            />
                                        </Box>
                                    </Box>
                                    <Box display={{xs: 'block', sm: 'flex'}}>
                                        <Box flex={1} >
                                            <TextInput
                                                source="businessInformation.businessAddress.addressState"
                                                resource="payouts"
                                                fullWidth
                                                label='resources.payout.page.businessInformation.businessAddress.addressState'
                                                helperText={false}
                                                disabled={true}
                                            />
                                        </Box>
                                        <Box flex={1} >
                                            <TextInput
                                                source="businessInformation.businessAddress.zipcode"
                                                resource="payouts"
                                                fullWidth
                                                label='resources.payout.page.businessInformation.businessAddress.zipcode'
                                                helperText={false}
                                                disabled={true}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Separator/>
                            <Box mt="1em"/>

                            {/* Consumer Information */}
                            <Typography variant="h6" gutterBottom>
                                {translate(
                                    'resources.payout.fieldGroups.receiverInformation'
                                )}
                            </Typography>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    {/*receiver information fields here*/}
                                    <Typography variant="h6" gutterBottom>
                                        {translate(
                                            'resources.payout.page.receiverInformation.details'
                                        )}
                                    </Typography>
                                    <Box flex={1}>
                                        <TextInput
                                            source="receiverInformation.firstName"
                                            resource="payouts"
                                            fullWidth
                                            label='resources.payout.page.receiverInformation.firstName'
                                            helperText={false}
                                        />
                                    </Box>
                                    <Box flex={1}>
                                        <TextInput
                                            source="receiverInformation.lastName"
                                            resource="payouts"
                                            fullWidth
                                            label='resources.payout.page.receiverInformation.lastName'
                                            helperText={false}
                                        />
                                    </Box>
                                    <Box flex={1} >
                                        <TextInput
                                            source="receiverInformation.receiverMobileNumber"
                                            resource="payouts"
                                            fullWidth
                                            label='resources.payout.page.receiverInformation.receiverMobileNumber'
                                            helperText={false}
                                        />
                                    </Box>
                                    <Box flex={1} >
                                        <TextInput
                                            type="email"
                                            source="receiverInformation.email"
                                            resource="payouts"
                                            fullWidth
                                            label='resources.payout.page.receiverInformation.email'
                                            helperText={false}
                                        />
                                    </Box>
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    {/*receiver information account details here*/}
                                    <Typography variant="h6" gutterBottom>
                                        {translate(
                                            'resources.payout.page.receiverInformation.accountInformation.details'
                                        )}
                                    </Typography>
                                    <TextInput
                                        source="receiverInformation.accountInformation.receiverDirectoryId"
                                        resource="payouts"
                                        label='resources.payout.page.receiverInformation.accountInformation.receiverDirectoryId'
                                        multiline
                                        fullWidth
                                        helperText={false}
                                    />
                                    <Box display={{xs: 'block', sm: 'flex'}}>
                                        <Box flex={1} >
                                            <TextInput
                                                source="receiverInformation.accountInformation.receiverDisplayAccountNumber"
                                                resource="payouts"
                                                fullWidth
                                                label='resources.payout.page.receiverInformation.accountInformation.receiverDisplayAccountNumber'
                                                helperText={false}
                                            />
                                        </Box>
                                    </Box>
                                    <Box display={{xs: 'block', sm: 'flex'}}>
                                        <Box flex={1} >
                                            <TextInput
                                                source="receiverInformation.accountInformation.receiverBankName"
                                                resource="payouts"
                                                fullWidth
                                                label='resources.payout.page.receiverInformation.accountInformation.receiverBankName'
                                                helperText={false}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Separator/>
                            <Box mt="1em"/>

                            {/* Payout Other Information */}
                            <Typography variant="h6" gutterBottom>
                                {translate(
                                    'resources.payout.fieldGroups.payoutOtherInfo'
                                )}
                            </Typography>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <TextInput
                                    source="payoutOtherInfo.resendCount"
                                    resource="payouts"
                                    label='resources.payout.page.payoutOtherInfo.resendCount'
                                    multiline
                                    fullWidth
                                    helperText={false}
                                    disabled={true}
                                />
                            </Box>

                            <Separator/>
                            <Box mt="1em"/>

                            {/* L2P Response Data */}
                            <Typography variant="h6" gutterBottom>
                                {translate(
                                    'resources.payout.fieldGroups.l2pResponseData'
                                )}
                            </Typography>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        source="l2pResponseData.transactionRsp.contactProfileId"
                                        label='resources.payout.page.l2pResponseData.transactionRsp.contactProfileId'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <TextInput
                                        source="l2pResponseData.transactionRsp.transPymtId"
                                        label='resources.payout.page.l2pResponseData.transactionRsp.transPymtId'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        source="l2pResponseData.transactionRsp.accountMask"
                                        label='resources.payout.page.l2pResponseData.transactionRsp.accountMask'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <TextInput
                                        source="l2pResponseData.transactionRsp.transId"
                                        label='resources.payout.page.l2pResponseData.transactionRsp.transId'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        source="l2pResponseData.transactionRsp.paymentProfileId"
                                        label='resources.payout.page.l2pResponseData.transactionRsp.paymentProfileId'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                    <TextInput
                                        source="l2pResponseData.transactionRsp.accountType"
                                        label='resources.payout.page.l2pResponseData.transactionRsp.accountType'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        source="l2pResponseData.transactionRsp.status.responseCode"
                                        label='resources.payout.page.l2pResponseData.transactionRsp.status.responseCode'
                                        resource="payouts"
                                        fullWidth
                                        helperText={false}
                                        disabled={true}
                                    />
                                </Box>
                                <Box flex={1} ml={{xs: 0, sm: '0.5em'}}>
                                </Box>
                            </Box>
                            <Separator/>
                            <Box mt="1em"/>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" gutterBottom>
                                {translate(
                                    'resources.payout.fieldGroups.identity'
                                )}
                            </Typography>
                            <div>
                                <SelectInput
                                    helperText={false}
                                    fullWidth
                                    resource="payouts"
                                    source="payoutState"
                                    label='resources.payout.page.payoutState'
                                    choices={[
                                        {
                                            id: 'Draft',
                                            name: 'Draft',
                                        },
                                        {
                                            id: 'Pending',
                                            name: 'Pending',
                                        },
                                        {
                                            id: 'Approved',
                                            name: 'Approved',
                                        },
                                        {
                                            id: 'Sent',
                                            name: 'Sent',
                                        },
                                        {
                                            id: 'Resent',
                                            name: 'Resent',
                                        },
                                        {
                                            id: 'Rejected',
                                            name: 'Rejected',
                                        },
                                        {
                                            id: 'Expired',
                                            name: 'Expired',
                                        },
                                        {
                                            id: 'Cancelled',
                                            name: 'Cancelled',
                                        },
                                        {
                                            id: 'Withdrawn',
                                            name: 'Withdrawn',
                                        },
                                        {
                                            id: 'Submitted',
                                            name: 'Submitted',
                                        },
                                        {
                                            id: 'Copied',
                                            name: 'Copied',
                                        },
                                        {
                                            id: 'Paid',
                                            name: 'Paid',
                                            disabled: true,
                                        },
                                        {
                                            id: 'Failed',
                                            name: 'Failed',
                                            disabled: true,
                                        },
                                    ]}
                                />
                            </div>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        type={"string"}
                                        source="payoutId"
                                        resource="payouts"
                                        label='resources.payout.page.payoutId'
                                        disabled={true}
                                        helperText={false}
                                        fullWidth
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        type="businessId"
                                        source="businessId"
                                        resource="payouts"
                                        label='resources.payout.page.businessId'
                                        validate={[required()]}
                                        disabled={true}
                                        helperText={false}
                                        fullWidth
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <TextInput
                                        source="receiverMobileNumber"
                                        resource="payouts"
                                        label='resources.payout.page.receiverMobileNumber'
                                        helperText={false}
                                        fullWidth
                                    />
                                </Box>
                            </Box>
                            <Box display={{xs: 'block', sm: 'flex'}}>
                                <Box flex={1} >
                                    <NumberInput
                                        source="invoiceNumber"
                                        step={1}
                                        resource="payouts"
                                        label='resources.payout.page.invoiceNumber'
                                        helperText={false}
                                        fullWidth
                                    />
                                </Box>
                            </Box>
                            <div>
                                <DateTimeInput
                                    source="createdAt"
                                    resource="payouts"
                                    label='resources.payout.page.createdAt'
                                    helperText={false}
                                    disabled={true}
                                    fullWidth
                                />
                            </div>
                            <div>
                                <DateTimeInput
                                    source="notificationSentDate"
                                    resource="payouts"
                                    label='resources.payout.page.notificationSentDate'
                                    helperText={false}
                                    disabled={true}
                                    fullWidth
                                />
                            </div>
                            <div>
                                <TextInput
                                    source="timeToLive"
                                    resource="payouts"
                                    label='resources.payout.page.timeToLive'
                                    helperText={false}
                                    fullWidth
                                />
                            </div>
                            <Separator/>
                            <Box mt="1em"/>
                            <Typography variant="h6" gutterBottom>
                                {translate(
                                    'resources.payout.fieldGroups.stateTimeline'
                                )}
                            </Typography>
                            <StateTimelines/>
                        </Grid>
                    </Grid>
                </div>
            </SimpleForm>
        </Edit>
    );
};

const PayoutTitle = () => {
    const record = useRecordContext<Payout>();
    return record ? <PayoutIdField record={record} size="32"/> : null;
}

export default PayoutTransactionEdit;
